export default {
  // ========== Header ==========
  didacticSuitcasePlan: "Didactic Suitcase Plan",
  subjectDescription: "Subject Description",

  // ========== First Table: General Information ==========
  academicUnit: "Academic Unit",
  subjectName: "Subject Name",
  duocCredits: "DUOC Credits",
  prerequisites: "Prerequisites",
  careerName: "Career Name(s)",
  technicalProfessional: "Technical/Professional",
  code: "Code",
  directedTeachingHoursSemester: "Directed Teaching Hours per Semester (Pedagogical)",
  teacherCount: "No. of Teachers",
  notApplicable: "Not Applicable",
  studyPlans: "Study Plans",
  directedTeachingHoursBreakdown: "In-Person Directed Teaching Hrs. / Non In-Person Directed Teaching",
  assistantCount: "No. of Assistants",
  formationLine: "Formation Line",
  transferableAcademicCredits: "Transferable Academic Credits (SCT)",
  assistantshipHours: "No. of Assistantship Hours",
  subjectFormat: "Subject Format (In-Person, FOL, DUAL)",
  programmingWeeks: "No. of Programming Weeks",
  autonomousWorkHours: "Autonomous Work Hours",
  publishDate: "Publish Date",

  // ========== Second Table: Description ==========
  methodologicalStrategies: "Methodological Strategies",
  inPersonLearningEnvironments: "In-Person Directed Teaching Learning Environment(s)",
  nonInPersonLearningEnvironments: "Non In-Person Directed Teaching Learning Environment(s)",
  transversalFinalEvaluation: "Transversal Final Evaluation (Evaluative situation and description)",

  // ========== Third Table: Training Map ==========
  trainingMap: "Training Map",
  instructionalDevelopmentPlan: "Instructional Development Didactic Suitcase Plan",
  learningResults: "Learning Outcomes",
  achievementIndicators: "Achievement Indicators",
  noInformation: "No information available",
  noLearningResults: "No Learning Outcomes",
  noAchievementIndicators: "No Achievement Indicators",
}
